<button
  class="collapsible-panel__header"
  type="button"
  [attr.aria-controls]="bodyId"
  [attr.aria-expanded]="isExpanded"
  (click)="toggle()">
  <span class="collapsible-panel__title" [id]="titleId">{{ title }}</span>
  <svg
    *ngIf="isExpanded"
    aria-hidden="true"
    class="collapsible-panel__icon"
    data-icon="minus"
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20">
    <circle cx="10" cy="10" r="9" stroke="#667892" stroke-width="1.5" />
    <path d="M6 10H14" stroke="#667892" stroke-width="1.5" stroke-linecap="round" />
  </svg>
  <svg
    *ngIf="!isExpanded"
    aria-hidden="true"
    class="collapsible-panel__icon"
    data-icon="plus"
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20">
    <circle cx="10" cy="10" r="9" stroke="#667892" stroke-width="1.5" />
    <path d="M10 6V14" stroke="#667892" stroke-width="1.5" stroke-linecap="round" />
    <path d="M6 10H14" stroke="#667892" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</button>
<div
  class="collapsible-panel__body"
  role="region"
  [attr.aria-labelledby]="titleId"
  [hidden]="!isExpanded"
  [id]="bodyId">
  <ng-content></ng-content>
</div>
